import { ChangeEvent, HTMLInputTypeAttribute, MutableRefObject } from "react";
import { useTranslation } from "react-i18next";
import { Fields } from "../../types/SchemaFactory";
import { FormikProps } from "formik";
import { getMetaParameterValue } from "../../validation-schemas/SchemaFactory";
import _ from "lodash";

interface CustomInputProps<Parent, Nested> {
    form: FormikProps<Parent>;
    name: keyof Parent;
    nestedKey?: keyof Nested;
    fields: Fields<Parent> | Fields<Nested>;
    className?: string;
    disabled?: boolean;
    inputRef?: MutableRefObject<HTMLInputElement>;
    type?: HTMLInputTypeAttribute;
    onChange?: (e?: ChangeEvent<HTMLInputElement>) => void;
}

function CustomInput<Parent, Nested>(props: CustomInputProps<Parent, Nested>) {
    const { t } = useTranslation();

    const fields = _.get(props.fields, props.nestedKey || props.name);
    const name = props.nestedKey ? `${props.name as string}.${props.nestedKey as string}` : (props.name as string);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (!_.get(props.form.touched, name)) {
            props.form.setFieldTouched(name as string, true);
        }
        props.form.handleChange(e);
        props.onChange && props.onChange(e);
    };

    return (
        <input
            type={props.type || fields.type}
            ref={props.inputRef}
            value={_.get(props.form.values, name as keyof Parent, "")}
            min={getMetaParameterValue(fields, "min") || 0}
            max={getMetaParameterValue(fields, "max") || 99999}
            name={name || ""}
            placeholder={t(fields.placeholderKey)}
            onChange={onChange}
            disabled={props.disabled}
            className={`${fields.type === "number" && "input-spinner-hidden"} input ${props.className}`}
        />
    );
}

export default CustomInput;
